module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_highfantasy.b9a6c3e9.png";